import { Button, MaskedInput, UIHeading3 } from '@cian/ui-kit';
import { ModalWindow } from '@cian/ui-kit/modal';
import { forwardRef } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { PHONE_MASK } from 'shared/utils/maskPhone';
import { Agreements } from './IAgreementsProps';
import s from './LoginWidget.module.css';
import { SmsWindow } from './SmsWindow';
import { useAuthorization } from '../../hooks/useAuthorization';

type AuthFormProps = { onAuth: () => void };

export const AuthForm = forwardRef<HTMLDivElement, AuthFormProps>(function Authform(props, ref) {
  const context = useApplicationContext();
  const { phoneInputDescription } = context.custom;
  const { onAuth } = props;
  const {
    phone,
    setPhone,
    uuid,
    setUuid,
    codeError,
    setCodeError,
    showAgreements,
    setShowAgreements,
    agreementsChecked,
    setAgreementsChecked,
    code,
    setCode,
    maskedPhone,
    handleSendPhone,
    handleResetPhone,
    handleSendCode,
  } = useAuthorization({ onAuth });

  function handleCloseModalWindow() {
    if (showAgreements) {
      setShowAgreements(false);
    } else {
      setUuid(null);
    }
  }

  const modalWindowHeader = showAgreements ? 'Согласие на обработку персональных данных' : 'Введите код из смс';

  const modalWindowContent = showAgreements ? (
    <Agreements onClose={() => setShowAgreements(false)} />
  ) : (
    maskedPhone !== null &&
    uuid !== null && (
      <SmsWindow
        uuid={uuid}
        phone={maskedPhone}
        code={code}
        codeError={codeError}
        agreementsChecked={agreementsChecked}
        setCode={setCode}
        setCodeError={setCodeError}
        onResetPhone={handleResetPhone}
        onEnterCode={handleSendCode}
        onResendPhone={handleSendPhone}
        onShowAgreements={() => setShowAgreements(true)}
        setAgreementsChecked={setAgreementsChecked}
      />
    )
  );

  return (
    <div ref={ref}>
      <div className={s.wrapper}>
        <div className={s.input}>
          <MaskedInput
            autoFocus
            placeholder={PHONE_MASK}
            mask={PHONE_MASK}
            size="M"
            value={phone}
            onChange={setPhone}
          />
          <p className={s.text}>
            {phoneInputDescription ??
              'Владелец готов сделать скидку на ипотеку, оставьте свой номер телефона и вы сможете увидеть детали по предложению и подать заявку'}
          </p>
        </div>
        <div className={s['button-wrapper']}>
          <Button fullWidth onClick={handleSendPhone} disabled={maskedPhone === null}>
            Войти
          </Button>
        </div>
      </div>

      <ModalWindow
        open={uuid !== null}
        header={<UIHeading3>{modalWindowHeader}</UIHeading3>}
        content={modalWindowContent}
        maxWidth={500}
        onClose={handleCloseModalWindow}
      />
    </div>
  );
});
